<!--店铺管理-->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.add"
                    @click="add(1)">{{ permission.add }}</el-button>
            </div>
            <div class="search-ctn-rigth">
                <div class="search-name">平台</div>
                <el-select class="search-item" size="small" clearable v-model.trim="searchData.PlatformId" @visible-change="platformVisibleChange($event)">
                    <el-option v-for="item in platformList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
                <div class="search-name">店铺名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Key" placeholder="请输入店铺名称"></el-input>
                <el-button style="margin-left: 10px;"  size="small" class="search-btn btn-primary" @click="handleSearch()">查询</el-button>
                <el-button class="search-btn btn-primary"  size="small" @click="reset()">重置</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="ShopName" label="店铺名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Platform" label="所属平台" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="GoodsRsCount" label="关联商品"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="GoodsUpCount" label="已上架商品"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Creator" label="创建人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="180px" prop="CreateTime" label="创建时间"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column width="180px" prop="UpdateTime" label="最后更新时间"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="编辑" size="mini" type="text" v-if="permission.edit"
                                    @click="add(2, scope.row)">{{ permission.edit }}</el-button>
                                <el-button size="mini" @click="shopRsStaff(scope.row)" v-if="permission.staffRs"
                                    type="text">{{ permission.staffRs }}</el-button>
                                <el-button size="mini" style="color: orange" @click="gotoRsDetail(scope.row)"
                                    v-if="permission.goodsRs" type="text">{{ permission.goodsRs }}</el-button>
                                <el-button size="mini" style="color: red" @click="del(scope.row)" v-if="permission.del"
                                    type="text">{{ permission.del }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"></el-pagination>
            </div>

            <el-dialog :close-on-click-modal="false" :title="dialogEditType == 1 ? '新增店铺' : '编辑店铺'"
                :visible.sync="dialogEditVisible" width="600px">
                <div class="dialog-content" v-if="dialogEditVisible">
                    <div v-loading="loading">
                        <div class="form-main">
                            <el-form :model="submitData" :rules="rules" ref="submitData" label-width="80px"
                                class="formData">
                                <div class="formData-top">
                                    <div class="form-left form-column">
                                        <el-form-item label="店铺名称" prop="ShopName">
                                            <el-input v-model="submitData.ShopName" placeholder="请输入"></el-input>
                                        </el-form-item>
                                        <el-form-item label="所属平台" prop="PlatformId">
                                            <el-select v-model="submitData.PlatformId">
                                                <el-option v-for="item in platformList" :key="item.Id"
                                                    :label="item.Name" :value="item.Id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-form>
                            <div class="dialog-footer">
                                <el-button class="btn-primary" @click="submitFrom()">提交</el-button>
                                <el-button @click="cancel()">取消</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="staffTitlie" :visible.sync="dialogStaffRsVisible"
                width="850px">
                <div class="dialog-content" v-if="dialogStaffRsVisible">
                    <div v-loading="loading">
                        <div class="form-main">
                            <div class="search-ctn">
                                <div class="search-ctn-left">
                                    <div class="search-name">部门</div>
                                    <el-cascader
                                        ref="orgCascader"
                                        class="search-item"
                                        v-model="staffDialogData.Org"
                                        :options="orgList"
                                        :props="cascaderProps"
                                        size="small"
                                        clearable
                                    ></el-cascader>
                                    <div class="search-name">员工名称</div>
                                    <el-input class="search-item" size="small" v-model.trim="staffDialogData.Key" placeholder="请输入员工名"></el-input>
                                    <div class="search-name">状态</div>
                                    <el-select class="search-item" size="small" v-model.trim="staffDialogData.State">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="未绑定" value="0"></el-option>
                                        <el-option label="已绑定" value="1"></el-option>
                                    </el-select>
                                    <el-button style="margin-left: 10px;" size="mini" class="search-btn btn-primary" @click="handleSearch1()">查询</el-button>
                                    <el-button class="search-btn btn-primary" size="mini" @click="resetSf()">重置</el-button>
                                </div>
                            </div>
                            <template>
                                <div class="table-ctn table-ctn1">
                                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="staffRsData" border height="560" style="width: 100%">
                                        <el-table-column width="140" prop="StaffName" label="员工"></el-table-column>
                                        <el-table-column width="140" prop="Account" label="账号"></el-table-column>
                                        <el-table-column prop="OrgName" label="部门"></el-table-column>
                                        <el-table-column width="110" prop="IsRs" label="状态">
                                            <template slot-scope="scope">
                                                {{ scope.row.IsRs ? '已绑定':'未绑定' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column width="110" label="操作">
                                            <template slot-scope="scope">
                                                <div class="ops-ctn">
                                                    <el-button title="加入店铺" size="mini" type="text" v-if="!scope.row.IsRs"
                                                        @click="setStaff(0, scope.row)">加入店铺</el-button>
                                                    <el-button size="mini" style="color: red" v-else @click="setStaff(1, scope.row)"
                                                        type="text">移除绑定</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </template>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';

export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { elTableColumn, breadcrumb },
    data() {
        return {
            noData: false,
            loading: false,
            Id: '',
            searchData: {
                PlatformId:'',
                Key:'',
                page: 1,
                limit: 15,
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            dialogEditType: 0,
            dialogEditVisible: false,
            platformList: [],
            submitData: {
                Id: '',
                ShopName: '',
                PlatformId: '',
            },
            rules: {
                ShopName: [
                    {
                        required: true,
                        message: "该项必填",
                        trigger: "blur"
                    }
                ],
                PlatformId: [
                    {
                        required: true,
                        message: "该项必选",
                        trigger: "blur"
                    }
                ],
            },
            dialogStaffRsVisible: false,
            staffTitlie: '',
            staffRsData: [],
            staffDialogData: {
                ShopId:'',
                Org:'',
                Key: '',
                State: '',
            },
            orgList:[],
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getPermission('ecShopDetailManage');
    },
    methods: {
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetShopsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => { });
        },
        submitFrom() {
            if (!this.submitData.ShopName) {
                this.$util.warningMsg("请输入店铺名称");
                return false;
            }
            if (!this.submitData.PlatformId) {
                this.$util.warningMsg("请选择所属平台");
                return false;
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/addOrEditShop',
                    data: this.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg)
                        this.dialogEditVisible = false;
                        this.getTableData();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: row.GoodsRsCount > 0 ? '当前店铺还有关联的商品，是否确认删除？' : '确定要删除该数据吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/delShop?id=' + row.Id
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => { });
                }
            });
        },
        add(type, data) {
            if (data) {
                this.submitData = {
                    Id: data.Id,
                    ShopName: data.ShopName,
                    PlatformId: data.PlatformId,
                }
            } else {
                this.submitData = {
                    Id: '',
                    ShopName: '',
                    PlatformId: '',
                }
            }
            this.dialogEditType = type;
            this.dialogEditVisible = true;

        },
        cancel() {
            this.dialogEditVisible = false;
        },
        shopRsStaff(row){
            this.resetSf();
            this.staffDialogData.ShopId = row.Id;
            this.staffTitlie = row.ShopName;
            this.dialogStaffRsVisible = true;
            if(this.orgList == 0) this.getOrgTree();
            this.getShopRsStaffList();
        },
        getShopRsStaffList() {

            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetShopsRsStaffList',
                    data: this.staffDialogData
                })
                .then(res => {
                    let data = res.data;
                    this.staffRsData = data;
                    //this.staffRsDataLength = res.count;
                })
                .catch(() => { }) 
                .finally(() => {
                    this.loading = false;
                });
        },
        setStaff(type,row){
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/shopRsStaff',
                    data: { Id : this.staffDialogData.ShopId, StaffId : row.Id , Type : type}
                })
                .then(res => {
                    if(res.errcode == 0){
                        this.$util.successMsg(res.errmsg);
                        this.getShopRsStaffList();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTree'
                })
                .then(res => {
                    if (res.data) {
                        this.orgList = this.getTreeData(res.data);
                    }
                });
        },
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        platformVisibleChange(event){
            let that = this;
            if (event) {
                if (that.platformList.length == 0) that.getPlatformList();
            }
        },
        getPlatformList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetPlatformList'
                })
                .then(res => {
                    if (res.data) {
                        this.platformList = res.data;
                    } else {
                        this.platformList = [];
                    }
                });
        },
        handleSearch(){
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        reset() {
            this.searchData = {
                PlatformId: '',
                Key: '',
                page: 1,
                limit: 15,
            };
        },
        handleSearch1(){
            this.staffDialogData.page = 1;
            this.getShopRsStaffList();
        },
        handleSizeChange1(val) {
            this.staffDialogData.page = 1;
            this.staffDialogData.limit = val;

            if(val == 15){
                this.sf_height = 280;
            }else{
                val = val > 30 ? 30 : val;
                this.sf_height = 280 + ((val / 10) * 80)
            }
            this.getShopRsStaffList();
        },
        handleCurrentChange1(val) {
            this.staffDialogData.page = val;
            this.getShopRsStaffList();
        },
        resetSf() {
            var sId = this.staffDialogData.ShopId;
            this.staffDialogData = {
                ShopId:sId,
                Name: '',
                Org:'',
                State: ''
            };
        },
        gotoRsDetail(item) {
            // 打开页面
            this.$router.push(`/ecPlatform/ecShopsRsGoodsList?ShopId=${item.Id}&ShopName=${item.ShopName}&Platform=${item.Platform}`);
        },
    }
};
</script>
<style lang="less" scoped>
.el-input {
    width: 90%;
}

.el-select {
    width: 90%;
}
.sf-page{
    margin-top: 20px;
}
.dialog-footer {
    text-align: right;
}
.table-ctn1::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
.table-ctn1 .el-table{
    margin-bottom: 0px;
}
/deep/.table-ctn1 .el-table .el-table__body .el-table__row td{
    padding: 4px 0 !important;
}
.search-ctn-rigth{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}

@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.el-table .error-row {
    background: rgb(255, 176, 176);
}
</style>
